<template>
    <div>
        <div class="demo-spin-article">
            <div class="mb-3">
                <div class="col-md-12">
                    <label class="form-col-label control-label required">{{
                        $t('collateralAsset.assetCode')
                    }}</label>
                    <input
                        ref="asset_code"
                        v-model="model.asset_code"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('asset_code') }"
                        maxlength="20"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('asset_code')"
                    >
                        {{ errors.first('asset_code') }}
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="col-md-12">
                    <label class="form-col-label control-label required">{{
                        $t('collateralAsset.assetName')
                    }}</label>
                    <input
                        v-model="model.asset_name"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('asset_name') }"
                        maxlength="100"
                    />
                    <div
                        class="invalid-feedback"
                        v-if="errors.has('asset_name')"
                    >
                        {{ errors.first('asset_name') }}
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <div class="col-md-12">
                    <label class="form-col-label control-label">{{
                        $t('collateralAsset.description')
                    }}</label>
                    <textarea
                        v-model="model.description"
                        rows="3"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('description') }"
                    ></textarea>
                    <div class="invalid-feedback" v-if="errors.has('description')">
                        {{ errors.first('description') }}
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <ts-checkbox v-model="model.is_active">{{
                    $t('collateralAsset.isActive')
                }}</ts-checkbox>
            </div>
            <div slot="footer">
                <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
                    <ts-button
                        @click.prevent="() => $emit('cancel')"
                        class="btn-gray"
                    >
                        {{ $t('cancel') }}</ts-button
                    >
                    <ts-button
                        color="primary"
                        v-if="!isUpdate"
                        outline
                        :waiting="waiting_new"
                        :disabled="waiting"
                        @click.prevent="onSaveAddNew"
                    >
                        {{ $t('saveAddNew') }}</ts-button
                    >
                    <ts-button
                        color="primary"
                        v-if="!isUpdate"
                        :waiting="waiting"
                        :disabled="waiting_new"
                        @click.prevent="onSave"
                    >
                        {{ $t('save') }}</ts-button
                    >
                    <ts-button
                        v-if="isUpdate"
                        color="primary"
                        @click.prevent="onUpdate"
                        :waiting="waiting"
                    >
                        {{ $t('update') }}</ts-button
                    >
                </div>
            </div>
        </div>
        <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'

export default {
    name: 'collateralAssetForm',
    data () {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            waiting_new: false,
            model: {
                asset_code: null,
                asset_name: null,
                description: null,
                is_active: true
            }
        }
    },
    computed: {
        ...mapState('creditOperation/collateralAsset', ['edit_data']),
        isUpdate () {
            return !isEmpty(this.edit_data)
        }
    },
    methods: {
        onSaveAddNew () {
            this.errors = new Errors()
            this.waiting_new = true
            this.$store
                .dispatch('creditOperation/collateralAsset/store', this.model)
                .then(response => {
                    this.notice({ type: 'success', text: response.message })
                    this.clearInput()
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.waiting_new = false
                })
        },
        onSave () {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('creditOperation/collateralAsset/store', this.model)
                .then(response => {
                    this.notice({ type: 'success', text: response.message })
                    this.$emit('cancel')
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        onUpdate () {
            this.waiting = true
            this.$store
                .dispatch('creditOperation/collateralAsset/update', {
                    id: this.edit_data.asset_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({ type: 'success', text: response.message })
                    this.$emit('cancel')
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        setEditData () {
            this.$nextTick(function () {
                this.$refs.asset_code.focus()
            })
            if (!isEmpty(this.edit_data)) {
                this.model.asset_code = this.edit_data.asset_code
                this.model.asset_name = this.edit_data.asset_name
                this.model.description = this.edit_data.description
                this.model.is_active = this.edit_data.is_active
            }
        },
        clearInput () {
            this.model.asset_code = null
            this.model.asset_name = null
            this.model.description = null
            this.model.is_active = true
        },
        notice (not) {
            this.$Notice[not.type]({
                title: 'COLLATERAL ASSET',
                desc: not.text
            })
        }
    },
    watch: {
        edit_data: {
            handler () {
                this.setEditData()
            },
            immediate: true
        }
    }
}
</script>
